// Keep analytics calls in one place so components are provider-agnostic.
import posthog, { isPostHogEnabled } from '../posthog';

declare global {
  function gtag(...args: any[]): void;
}

export const trackEvent = (eventName: string, parameters: Record<string, any> = {}) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', eventName, parameters);
  }

  if (isPostHogEnabled) {
    posthog.capture(eventName, parameters);
  }
};

export const trackSocialClick = (platform: string) => {
  trackEvent('social_click', {
    event_category: 'engagement',
    event_label: platform,
    platform: platform
  });
};

export const trackProjectClick = (projectName: string) => {
  trackEvent('project_click', {
    event_category: 'engagement',
    event_label: projectName,
    project_name: projectName
  });
};

export const trackScrollDepth = (depth: number) => {
  trackEvent('scroll_depth', {
    event_category: 'engagement',
    depth: depth
  });
};

export const trackChatOpen = () => {
  trackEvent('chat_open', {
    event_category: 'engagement'
  });
};

export const trackChatMessage = (message: string) => {
  trackEvent('chat_message', {
    event_category: 'engagement',
    message
  });
};
